import React from "react";
import {CircularProgress, Stack, Tab, TabList, TabPanel, Tabs} from "@mui/joy";
import Typography from "@mui/joy/Typography";
import UserSubscriberContext from "../../context/UserSubscriberContext";
import BaseApi from "../../utils/BaseApi";
import SliceCard from "./SliceCard";


class SliceTab extends React.Component {
    static contextType = UserSubscriberContext

    constructor(props) {
        super(props);
        this.state = {
            slicesAll: null,
            slicesMy: null,
        };
    }

    async componentDidMount() {
        await this.retrieveSlices();
    }

    async retrieveSlices(){
        const api = new BaseApi();
        let url = 'slice';
        let params = {
            opportunity: this.props.opportunity.id,
            page_size: 10000,
        }
        let response = await api.get(url, params);
        this.setState(
            {
                slicesAll: response.data.results,
                slicesMy: response.data.results.filter(
                    (s) => (s.operator.id === this.context.subscriberObject.id)
                ),
            }
        );
    }

    render() {
        if (!this.state.slicesAll || !this.state.slicesMy) {
            return (<CircularProgress/>)
        }
        return (
            <Tabs
                defaultValue={'sliceMy'}
                sx={{
                    p: 0
                }}
                variant={'soft'}
            >
                <TabList>
                    <Tab
                        value={'sliceMy'}
                    >
                        <Typography
                            level={'body-sm'}
                            sx={{
                                display: 'inline',
                                verticalAlign: 'middle',
                            }}
                        >
                            Мои
                        </Typography>
                    </Tab>
                    <Tab
                        value={'sliceAll'}
                    >
                        <Typography
                            level={'body-sm'}
                            sx={{
                                display: 'inline',
                                verticalAlign: 'middle',
                            }}
                        >
                            Все
                        </Typography>
                    </Tab>
                </TabList>
                <Stack
                    sx={{
                        flexGrow: 4,
                        height: '80%',
                    }}
                >
                    <TabPanel
                        value={'sliceMy'}
                        sx={{
                            p: 0,
                            mt: 1,
                            width: '100%',
                            height: '100%',
                            overflowY: 'scroll',
                        }}
                    >
                        <Stack
                            spacing={1}
                        >
                            {
                                this.state.slicesMy.map(
                                    (s) => (
                                        <SliceCard
                                            key={'SliceCard'+s.id}
                                            slice={s}
                                        />
                                    )
                                )
                            }
                        </Stack>

                    </TabPanel>
                    <TabPanel
                        value={'sliceAll'}
                        sx={{
                            p: 0,
                            mt: 1,
                            width: '100%',
                            height: '100%',
                            overflowY: 'scroll',
                        }}
                    >
                        <Stack
                            spacing={1}
                        >
                            {
                                this.state.slicesAll.map(
                                    (s) => (
                                        <SliceCard
                                            key={'SliceCard'+s.id}
                                            slice={s}
                                            showOperator={true}
                                        />
                                    )
                                )
                            }
                        </Stack>
                    </TabPanel>
                </Stack>
            </Tabs>
        )
    }
}

export default SliceTab